export enum IconLibrary {
  material = 'material',
  ionic = 'ionic',
}
